<!-- eslint-disable max-len -->
<template>
  <div class="properties-field-content">
    <!-- Title -->
    <div class="section-field input-field pb-0 border-0">
      <div class="configuration-section">
        <h4 class="configuration-section-title">General</h4>
        <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
          <label> Title </label>
          <j-input
            v-model="dataSetup.title"
            :error-required="$v.dataSetup.title.$error"
            placeholder="Type title for this component"/>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => null,
    },
    dataComponent: {
      type: Object,
      default: () => null,
    },
    dataEdit: {
      type: Object,
      default: () => null,
    },
    pagesId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      dataSetup: {
        title: '',
        component: null,
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  created() {
    if (!this.dataEdit) {
      this.dataSetup.component = this.dataComponent;
    } else {
      const info = JSON.parse(this.dataEdit.info);
      this.dataSetup.title = this.dataEdit.name;
      const params = {
        limit: 1,
        page: 1,
        filter: JSON.stringify({ id: info.canvas_id }),
      };

      this.findCanvas(params).then((res) => {
        if (res) {
          const dataCanvas = res[0];
          dataCanvas.label = dataCanvas.name;
          this.dataSetup.component = dataCanvas;
        }
      });
    }
  },

  methods: {
    ...mapActions('jStoreApplication', ['getDetailForm']),
    ...mapActions('jStoreFormUi', ['findCanvas']),

    // eslint-disable-next-line consistent-return
    getData() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const dataField = {
          canvas_id: this.dataSetup.component.id,
        };
        const data = {
          value_id: '0',
          pages_id: `${this.pagesId}`,
          name: this.dataSetup.title,
          component_master_id: this.dataMaster.id,
          info: JSON.stringify(dataField),
          type_platform: 1,
        };
        if (this.dataEdit) data.order = this.dataEdit.order;
        return data;
      }
    },
  },

  validations: {
    dataSetup: {
      title: {
        required,
      },
      component: {
        required,
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/forms/jCanvasForm.vue